const EVENT_NAME = 'anforderungsai:view-register-cleanup';

export const registerViewCleanup = (cleanup) => {
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, {
      detail: typeof cleanup === 'function' ? cleanup : null,
    }),
  );
};
